import React, { Component } from 'react';

export default class GenericDropdown extends Component {

  render() {
    let height ={height: '35px'},
        marginBottom = this.props.disableMarginBottom ? {}: {marginBottom: '1rem'},
        disableBorderBottom = this.props.disableBorderBottom ? {borderBottom: 'none'} : {},
        backgroundColor = this.props.backgroundColor ? {backgroundColor:this.props.backgroundColor} : {};
    return (
      <div style={marginBottom}>
        <div className="card-header border-gray" style={Object.assign(disableBorderBottom, backgroundColor)}>
          <div className="col-12 col-sm-3 p-0">
            <h6>{this.props.text}</h6>
          </div>
          <div className={`col-12 col-sm-3 p-0 ${this.props.dropdownError ? 'has-danger' : ''} `}>
            <select id="select" name="select" className={`form-control w-100 pl-1`} size="1" style={height} onChange={this.props.onSelectChange} value={this.props.value}>
              <option value="-1">{this.props.emptySelectMsg}</option>
              {this.props.list.map((l,idx) => {
                    return(<option value={idx} key={idx}>{l.name}</option>)
                  })
              }
            </select>
          </div>
        </div>
      </div>
    )
  }
}
